<template>
    <v-app class="v-appNoBackground">
        <Nav class="fixed-top" ref="nav"/>
        <router-view @show-loading-pop-up="showLoadingPopUp"
                     @reset-loading-pop-up="resetLoadingPopUp"
                     @authChanged="redrawNav"
                     class="router-view">
        </router-view>
        <Footer/>

        <v-bottom-sheet persistent v-model="loadingPopUp.loading" inset>
            <v-sheet class="text-center" height="125px">
                <div class="flexRow" style="justify-content: center">
                    <h6 class="py-3 m-3">{{this.loadingPopUp.text}}</h6>
                    <v-btn color="black" large icon :loading="true" class="py-3 m-3"/>
                </div>
            </v-sheet>
        </v-bottom-sheet>
        <v-btn style="right: 10px; bottom: 50px; position: fixed" v-if="showScrollToTop" :color="secondaryColor"
               fab
               @click="scrollToTop">
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import Nav from './components/Nav.vue';
    import Footer from './components/Footer.vue';

    export default {
        name: 'Syncware',
        components: {
            Nav,
            Footer,
        },
        data: () => {
            return {
                loadingPopUp: {
                    loading: false,
                    text: 'loading...'
                },
                showScrollToTop: true,
            }
        },
        created() {
            setInterval(this.checkScrollPosition, 1000);
        },
        methods: {
            showLoadingPopUp(text) {
                this.loadingPopUp.text = "Loading...";
                if (text != null && text.length > 0) this.loadingPopUp.text = text;
                this.loadingPopUp.loading = true;
            }
            ,
            resetLoadingPopUp() {
                this.loadingPopUp.loading = false;
            },
            redrawNav: function (event) {
                this.$refs.nav.redrawNav();
            },
            scrollToTop() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            checkScrollPosition() {
                this.showScrollToTop = window.scrollY > 150;
            }
        }
    }
</script>
